import {
  LOAD_PLANT_ACCOUNT,
  SHOW_PLANT_ACCOUNT,
  CREATE_PLANT_ACCOUNT,
  UPDATE_PLANT_ACCOUNT,
  DELETE_PLANT_ACCOUNT,
  IMPORT_PLANT_ACCOUNT,
  EXPORT_PLANT_ACCOUNT,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    acc_no: "",
    acc_name: "",
    bank_ids: [],
  },
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_PLANT_ACCOUNT.REQUEST:
    case SHOW_PLANT_ACCOUNT.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case CREATE_PLANT_ACCOUNT.REQUEST:
    case UPDATE_PLANT_ACCOUNT.REQUEST:
    case DELETE_PLANT_ACCOUNT.REQUEST:
    case IMPORT_PLANT_ACCOUNT.REQUEST:
    case EXPORT_PLANT_ACCOUNT.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_PLANT_ACCOUNT.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_PLANT_ACCOUNT.SUCCESS:
      return {
        ...state,
        data: action.payload.data.data,
        loading: false,
      };

    case CREATE_PLANT_ACCOUNT.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        loading: false,
      };

    case UPDATE_PLANT_ACCOUNT.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_PLANT_ACCOUNT.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };

    case IMPORT_PLANT_ACCOUNT.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_PLANT_ACCOUNT.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };

    case LOAD_PLANT_ACCOUNT.FAILURE:
    case SHOW_PLANT_ACCOUNT.FAILURE:
    case CREATE_PLANT_ACCOUNT.FAILURE:
    case UPDATE_PLANT_ACCOUNT.FAILURE:
    case DELETE_PLANT_ACCOUNT.FAILURE:
    case IMPORT_PLANT_ACCOUNT.FAILURE:
    case EXPORT_PLANT_ACCOUNT.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    default:
      return state;
  }
};
